/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonMiniActionNavbar.vue?vue&type=template&id=bb527cee&scoped=true"
import script from "./ButtonMiniActionNavbar.ts?vue&type=script&lang=ts&external"
export * from "./ButtonMiniActionNavbar.ts?vue&type=script&lang=ts&external"
import style0 from "./ButtonMiniActionNavbar.vue?vue&type=style&index=0&id=bb527cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb527cee",
  null
  
)

export default component.exports